export interface CloseIconProps {
  color?: string;
  className?: string;
}

const CloseIcon = ({ color = 'currentColor', className }: CloseIconProps) => (
  <svg width="24" height="24" fill="none" className={className} role="img" aria-labelledby="close">
    <title id="Close">Close</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m20.485 4.929-1.414-1.414L12 10.585l-7.071-7.07-1.414 1.414 7.07 7.07-7.07 7.072 1.414 1.414 7.07-7.071 7.072 7.071 1.414-1.414L13.414 12l7.071-7.071Z"
      fill={color}
    />
  </svg>
);

export default CloseIcon;
